// avstemming-receivables-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avbk.assess.notAssessed': 'Not assessed',
  'avbk.assess.expectedPaid': 'OK – expected to be paid',
  'avbk.paidAfterPeriod': 'Paid after the period date',
  'avbk.assess.remind': 'To be reminded',
  'avbk.assess.toCollection': 'Send to collection',
  'avbk.assess.paymentPlan': 'Payment plan in place',
  'avbk.assess.matchPayment': 'To be matched against a payment',
  'avbk.assess.disputed': 'Disputed',
  'avbk.assess.issueCreditNote': 'Credit note to be issued',
  'avbk.assess.partialLoss': 'Partial loss risk',
  'avbk.assess.fullLoss': 'Full loss risk',
  'avbk.assess.writeDown': 'Write-down under consideration',
  'avbk.assess.writeOff': 'Write off as a loss',
  'avbk.assess.awaitingClient': 'Awaiting the client',
  'avbk.assess.awaitingDocs': 'Awaiting documentation',
  'avbk.followUpNext': 'Follow up next period',
  'avbk.risk.high': 'High',
  'avbk.risk.medium': 'Medium',
  'avbk.risk.low': 'Low',
  'avbk.risk.unknown': 'Unknown',
  'avbk.quick.needsAssessment': 'Needs assessment',
  'avbk.quick.allOpen': 'All open',
  'avbk.quick.overdue': 'Overdue',
  'avbk.quick.over90': 'Over 90 days',
  'avbk.quick.negative': 'Negative balances',
  'avbk.quick.creditNotes': 'Credit notes',
  'avbk.possibleDuplicates': 'Possible duplicates',
  'avbk.quick.collection': 'Collection',
  'avbk.lossRisk': 'Loss risk',
  'avbk.quick.missingDoc': 'Missing document',
  'avbk.assessedDone': 'Assessed',
  'avbk.daysLabel.na': 'Not relevant',
  'avbk.notOverdue': 'Not overdue',
  'avbk.overdueBy': 'Overdue by {days} days',
  'avbk.flags.none': 'None',
  'avbk.flags.more': '+{count} more',
  'avbk.page.noAccount': 'The area has no reconciliation account in this period.',
  'avbk.nav.overview': 'Overview',
  'avbk.nav.openItems': 'Open items',
  'avbk.nav.customerRisk': 'Customer and credit risk',
  'avbk.nav.controls': 'Checks',
  'avbk.nav.conclusion': 'Conclusion',
  'avbk.nav.blocked': 'Blocked',
  'avbk.nav.ready': 'Ready',
  'avbk.areaLabel': 'Accounts receivable',
  'avbk.page.title': 'Customer ledger and open items',
  'avbk.page.resetFilters': 'Reset filters',
  'avbk.page.customerFilter': 'Customer: {name}',
  'avbk.page.showAllCustomers': 'Show all customers',
  'avbk.page.accountFilter': 'Control account: {account}',
  'avbk.page.showAllAccounts': 'Show all control accounts',
  'avbk.page.ageFilter': 'Age group: {bucket}',
  'avbk.page.showAllAges': 'Show all age groups',
  'avbk.customer': 'Customer',
  'avbk.page.docNo': 'Doc. no.',
  'avbk.type': 'Type',
  'avbk.invoiceDate': 'Invoice date',
  'avbk.dueShort': 'Due',
  'avbk.page.original': 'Original',
  'avbk.openAmount': 'Open amount',
  'avbk.daysOverdue': 'Days overdue',
  'avbk.collection': 'Collection',
  'avbk.alert': 'Alert',
  'avbk.assessment': 'Assessment',
  'avbk.seeAssessment': 'View assessment',
  'avbk.assess': 'Assess',
  'avbk.page.noMatch': 'No customer items match the filters.',
  'avbk.page.noOpenItems': 'No open customer items in this period. If the client has no outstanding invoices, there is no subledger to reconcile.',
  'avbk.header.controlAccount': 'Control account {accounts}',
  'avbk.responsible': 'Responsible: {name}',
  'avbk.header.ledgerVsSubledger': '{area} – general ledger vs subledger',
  'avbk.header.noControlAccount': 'No control account in the area',
  'avbk.header.ledgerMatches': 'General ledger and subledger match',
  'avbk.header.ledgerDiverges': 'General ledger and subledger diverge',
  'avbk.header.noSubledgerAccount': 'No control account with a subledger',
  'avbk.header.itemsNeedAssessment': '{count} subledger items require assessment before the reconciliation can be sent for review.',
  'avbk.header.noItemsLeft': 'No subledger items remain to be assessed.',
  'avbk.balance.title': 'Automatic balance reconciliation',
  'avbk.balance.computedAt': 'The subledger is calculated as of {date}',
  'avbk.balance.subsequent': 'Subsequent events checked up to and including {date}',
  'avbk.balance.booked': 'Booked balance, control account with subledger',
  'avbk.balance.sumOpen': 'Total open items in the customer subledger',
  'avbk.difference': 'Difference',
  'avbk.balance.noSubledger': 'None of the area\'s accounts is the accounts receivable account the app books sales against ({account}). There is then no subledger to compare the balance with, and the difference must be explained on the account itself.',
  'avbk.balance.mismatch': 'The control account does not match the subledger. The difference must be explained before the area can be reconciled — see the direct postings further down.',
  'avbk.balance.openingBalance': 'Balance previous period',
  'avbk.balance.change': 'Change in the period',
  'avbk.balance.openInvoices': 'Open invoices',
  'avbk.balance.openCreditNotes': 'Open credit notes',
  'avbk.balance.totalItems': 'Total items in the check',
  'avbk.balance.customersWithBalance': 'Customers with a balance',
  'avbk.accounts.title': 'Control accounts',
  'avbk.accounts.empty': 'No balance sheet accounts are linked to accounts receivable in this period. Without a control account there is no booked balance to compare the subledger with.',
  'avbk.accounts.controlAccount': 'Control account',
  'avbk.accounts.bookedBalance': 'Booked balance',
  'avbk.accounts.subledgerBalance': 'Subledger balance',
  'avbk.status': 'Status',
  'avbk.noSubledger': 'No subledger',
  'avbk.accounts.deviation': 'Deviation',
  'avbk.matches': 'Matches',
  'avbk.accounts.open': 'Open account',
  'avbk.control.ledgerVsSubledger': 'General ledger vs subledger',
  'avbk.control.ledgerVsSubledgerHint': 'Booked balance compared with the sum of the open items at period end.',
  'avbk.control.old': 'Old items over 90 days',
  'avbk.control.oldHint': 'Open items overdue by more than 90 days.',
  'avbk.control.negative': 'Negative customer balances',
  'avbk.control.negativeHint': 'Items showing an amount the customer is owed.',
  'avbk.control.affected': '{count} affected items',
  'avbk.control.duplicatesHint': 'Same customer, same invoice date and same amount.',
  'avbk.control.collectionNotices': 'Collection notices sent',
  'avbk.control.collectionNoticesHint': 'Items where the client has sent a collection notice from Plumme.',
  'avbk.control.lossToAssess': 'Loss risk to assess',
  'avbk.control.lossToAssessHint': 'Items overdue by more than 90 days or escalated to a collection notice. Write-downs are decided by the accountant.',
  'avbk.control.missingDoc': 'Missing invoice document',
  'avbk.control.missingDocHint': 'Items without a stored invoice document.',
  'avbk.control.over30': 'Items overdue by more than 30 days',
  'avbk.control.over30Hint': 'Open items overdue by between 31 and 90 days.',
  'avbk.control.partPaid': 'Partly paid but still open',
  'avbk.control.partPaidHint': 'Items with a recorded payment that remain open nevertheless.',
  'avbk.control.unmatchedCredit': 'Credit notes that are not matched',
  'avbk.control.unmatchedCreditHint': 'Open credit notes that can be offset against invoices.',
  'avbk.control.creditAfter': 'Credit note after the period date',
  'avbk.control.creditAfterHint': 'Credit note issued after the period date on an invoice that was open. May be an accrual or valuation matter.',
  'avbk.control.paidAfterHint': 'Items open at the period date that were paid afterwards — normally positive evidence.',
  'avbk.control.directPosted': 'Posted directly to the control account',
  'avbk.control.directPostedHint': 'General ledger lines on the control accounts that do not come from an invoice or a payment.',
  'avbk.overCreditLimit': 'Customers over credit limit',
  'avbk.control.overLimitHint': 'Customers with an open balance above the credit limit on the customer card.',
  'avbk.control.title': 'Control card',
  'avbk.control.summary': 'Automatic checks run: {checks} of {checks} · Checks with findings: {findings} · Items requiring manual assessment: {unassessed}',
  'avbk.control.hide': 'Hide',
  'avbk.control.showAll': 'Show all automatic checks',
  'avbk.control.activeFilter': 'Active filter: {label} · {count} items',
  'avbk.control.removeFilter': 'Remove filter',
  'avbk.control.creditNote': 'Invoice {invoice} ({customer}) was open as of {date}. Credit note {credit} was issued {creditDate} — possibly an accrual or valuation matter. Plumme does not automatically decide which period the credit note belongs to.',
  'avbk.aging.title': 'Age distribution (days overdue)',
  'avbk.aging.empty': 'No open customer items at period end — nothing to distribute by age.',
  'avbk.aging.note': 'Calculated from the due date, not the invoice date.',
  'avbk.aging.age': 'Age',
  'avbk.aging.itemCount': 'Number of items',
  'avbk.aging.share': 'Share',
  'avbk.aging.sumOpen': 'Total open items',
  'avbk.risk.concentrationTitle': 'Customer and concentration risk',
  'avbk.risk.concentrationEmpty': 'No customers have an open balance at period end. Concentration risk is measured by the open items, so without them there is no distribution to assess.',
  'avbk.risk.largestBalance': 'Largest customer balance',
  'avbk.risk.topFive': 'Top 5 customers of total balance',
  'avbk.risk.topFiveHint': 'How large a share of the open balance sits with the five largest customers.',
  'avbk.risk.noLimitSet': 'No limit set',
  'avbk.risk.noLimitHint': 'The credit limit is set on the customer card. Without a limit there is nothing to measure against.',
  'avbk.risk.multipleOld': 'Customers with several old items',
  'avbk.risk.multipleOldHint': 'Customers with more than one item overdue by over 90 days.',
  'avbk.risk.withNotice': 'Customers with a collection notice',
  'avbk.risk.highRisk': 'Customers with high risk',
  'avbk.risk.totalOpen': 'Total open balance',
  'avbk.risk.overdueBalance': 'Overdue balance',
  'avbk.risk.oldest': 'Oldest item',
  'avbk.risk.creditLimit': 'Credit limit',
  'avbk.risk.utilised': 'Utilised',
  'avbk.collectionStatus': 'Collection status',
  'avbk.risk.risk': 'Risk',
  'avbk.risk.noLimitNote': 'None of the customers has a credit limit on the customer card. If one is set there, the open balance is measured against it here.',
  'avbk.loss.title': 'Loss risk and valuation',
  'avbk.loss.intro': 'Plumme has identified matters that may indicate a loss risk. The accountant must make and document the professional assessment — the system does not decide write-downs or write-offs automatically, and does not book them.',
  'avbk.loss.totalExposure': 'Total balance with loss risk',
  'avbk.loss.assessedAmount': 'Assessed amount at risk of loss',
  'avbk.loss.notDone': 'Not finished',
  'avbk.loss.assessedAmountHint': 'The sum of what the firm itself has assessed as at risk of loss, written down or written off.',
  'avbk.loss.highRiskItems': 'Items with high risk',
  'avbk.loss.none': 'No items with loss risk in this period.',
  'avbk.loss.invoice': 'Invoice',
  'avbk.loss.open': 'Open',
  'avbk.loss.proposed': 'Proposed',
  'avbk.daysCount': '{days} days',
  'avbk.direct.title': 'Direct postings on control account',
  'avbk.direct.empty': 'No general ledger lines on the control accounts come from anything other than an invoice or a payment. The check has run — it found nothing.',
  'avbk.direct.note': 'Posted directly to the control account without an invoice or payment. Such lines have no subledger entry, and often explain the difference between the general ledger and the subledger.',
  'avbk.direct.date': 'Date',
  'avbk.direct.voucher': 'Voucher',
  'avbk.direct.account': 'Account',
  'avbk.direct.text': 'Text',
  'avbk.direct.amount': 'Amount',
  'avbk.direct.sum': 'Total posted directly',
  'avbk.checks.title': 'Automatic checks',
  'avbk.checks.note': 'The checks do not tick off anything in the professional checklist. They tell the person ticking off what to have looked at.',
  'avbk.checks.check': 'Check',
  'avbk.checks.run': 'Run',
  'avbk.checks.result': 'Result',
  'avbk.checks.ran': 'Run',
  'avbk.checks.findingsCount': '{count} findings',
  'avbk.checks.noFindings': 'No findings',
  'avbk.derived.old': 'All material old items have been assessed',
  'avbk.derived.negative': 'Negative customer balances have been explained',
  'avbk.derived.duplicates': 'Possible duplicates have been assessed',
  'avbk.derived.unmatchedCredit': 'Credit notes that are not matched have been assessed',
  'avbk.derived.partPaid': 'Partly paid items have been investigated',
  'avbk.derived.collection': 'Collection cases have been reviewed',
  'avbk.derived.lossRisk': 'Items with loss risk have been assessed',
  'avbk.derived.creditAfter': 'Credit notes after the period date have been assessed',
  'avbk.derived.missingDoc': 'Items without an invoice document have been handled',
  'avbk.blocker.itemOne': '{count} subledger item requires assessment',
  'avbk.blocker.itemMany': '{count} subledger items require assessment',
  'avbk.blocker.diff': '{amount} of the difference against the subledger is unexplained',
  'avbk.blocker.lossOne': '{count} item with loss risk has not been assessed',
  'avbk.blocker.lossMany': '{count} items with loss risk have not been assessed',
  'avbk.blocker.checkpointOne': '{count} checkpoint remaining',
  'avbk.blocker.checkpointMany': '{count} checkpoints remaining',
  'avbk.checklist.title': 'Professional checklist',
  'avbk.checklist.titleReadOnly': 'Professional checklist (the preparer\'s, read-only)',
  'avbk.checklist.none': 'No checkpoints are defined for accounts receivable in this period.',
  'avbk.checklist.note': 'The points apply to the whole area. A tick is saved on all control accounts in the period.',
  'avbk.checklist.groupItems': 'Items that require handling',
  'avbk.checklist.countOf': '{done} of {total}',
  'avbk.checklist.handledOf': '{done} of {total} handled',
  'avbk.checklist.notApplicable': 'Not applicable this period',
  'avbk.checklist.followsAssessments': 'Follows from the assessments',
  'avbk.checklist.groupAssessments': 'Overall professional assessments',
  'avbk.checklist.groupReady': 'Readiness',
  'avbk.checklist.performedBy': 'Performed by {name}',
  'avbk.checklist.doneOfTotal': '{done} of {total} checkpoints completed',
  'avbk.conclusion.title': 'Conclusion and approval',
  'avbk.conclusion.label': 'Conclusion',
  'avbk.conclusion.placeholder': 'What does the review of accounts receivable show for this period?',
  'avbk.savedAsReason': 'Saved as the justification on the checkpoint «{label}».',
  'avbk.conclusion.remainingRisk': 'Remaining risk',
  'avbk.conclusion.nothingBlocking': 'Nothing remains that prevents the area from being sent for review.',
  'avbk.followup.title': 'Follow-up next period',
  'avbk.followup.none': 'No assessments are marked for follow-up next period.',
  'avbk.followup.badge': 'Follow up',
  'avbk.followup.noAction': 'No action noted',
  'avbk.followup.due': 'Due {date}',
  'avbk.followup.expectedPaid': 'Expected payment {date}',
  'avbk.followup.open': 'Open assessment',
  'avbk.conclusion.send': 'Send the area for review',
  'avbk.conclusion.oneThingLeft': 'One thing remains before the area can be sent.',
  'avbk.conclusion.thingsLeft': '{count} things remain before the area can be sent.',
  'avbk.drawer.reasonOverdue': 'The receivable is {days} days overdue',
  'avbk.drawer.reasonNotice': 'The client has sent a collection notice',
  'avbk.drawer.reasonReminders': '{count} reminders have been sent',
  'avbk.drawer.reasonPaidAfter': '{amount} paid after the period date',
  'avbk.drawer.reasonDuplicate': 'Possible duplicate of {others}',
  'avbk.drawer.unknownOrgNo': 'Unknown org. no.',
  'avbk.close': 'Close',
  'avbk.drawer.dueDate': 'Due date',
  'avbk.drawer.originalAmount': 'Original amount',
  'avbk.drawer.openAtPeriodEnd': 'Open at period end',
  'avbk.drawer.paidInPeriod': 'Paid in the period',
  'avbk.drawer.settledAfterDate': 'Open with {open} at period end · paid {settled} on {date} — normally positive evidence that the receivable was genuine and collectible.',
  'avbk.drawer.settledAfter': 'Open with {open} at period end · paid {settled} — normally positive evidence that the receivable was genuine and collectible.',
  'avbk.drawer.creditedAfter': 'Credit note {docNumber} for {amount} was issued {date}, after the period date. Whether it relates to revenue before the period date is a professional judgement — Plumme does not decide it.',
  'avbk.drawer.duplicateNote': 'Same customer, same invoice date and same amount as {others}. This is a suggestion for review, not a conclusion.',
  'avbk.drawer.noDocument': 'The item has no stored invoice document in Plumme.',
  'avbk.drawer.basis': 'The basis for the assessment:',
  'avbk.drawer.expectedDate': 'Expected payment date',
  'avbk.drawer.expectedAmount': 'Expected amount paid',
  'avbk.drawer.probability': 'Likelihood of payment',
  'avbk.drawer.proposedWriteDown': 'Proposed write-down',
  'avbk.drawer.proposedWriteOff': 'Proposed write-off',
  'avbk.drawer.amountsNote': 'The amounts are the firm\'s proposals. Plumme does not book any write-down or write-off of them — they remain beside the receivable until someone books it.',
  'avbk.drawer.rationaleRequired': 'Rationale (required)',
  'avbk.drawer.rationale': 'Rationale',
  'avbk.drawer.rationalePlaceholder': 'What does the review of this receivable show?',
  'avbk.drawer.action': 'Action',
  'avbk.drawer.actionPlaceholder': 'E.g. Follow up the collection status',
  'avbk.drawer.followUpDue': 'Follow-up deadline',
  'avbk.drawer.docsOnAccount': 'Documentation on the control account',
  'avbk.drawer.needsComment': 'This assessment requires a rationale.',
  'avbk.drawer.save': 'Save assessment',
  'avbk.drawer.requestDocs': 'Ask the client for documentation',
});
